"use client"

import * as React from "react"
import { cn } from "../../lib/utils"
import { Sheet, SheetContent, SheetTitle } from "./sheet"

export interface BottomSheetProps {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
  title?: React.ReactNode
  headerAction?: React.ReactNode
  showDragHandle?: boolean
  className?: string
  overlayClassName?: string
  contentClassName?: string
}

export function BottomSheet({
  isOpen,
  onClose,
  children,
  title,
  headerAction,
  showDragHandle = true,
  className,
  overlayClassName,
  contentClassName,
}: BottomSheetProps) {
  const handleOpenChange = (open: boolean) => {
    if (!open) {
      onClose()
    }
  }

  const fallbackTitle = "Bottom sheet dialog"

  return (
    <Sheet open={isOpen} onOpenChange={handleOpenChange}>
      <SheetContent
        side="bottom"
        className={cn("fixed! bottom-0! border-none bg-transparent p-0 shadow-none focus:outline-none", contentClassName)}
        overlayClassName={overlayClassName}
      >
        <div className={cn("mx-auto w-full max-w-md rounded-t-2xl max-h-[70vh] overflow-y-auto bg-white px-4 pb-6 pt-3", className)}>
          {showDragHandle && (
            <div className="mb-4 flex justify-center">
              <div className="h-[3px] w-12 rounded-full bg-[#B7B5AF]" />
            </div>
          )}

          {(title || headerAction) ? (
            <div className="mb-4 flex items-center justify-between gap-3">
              <SheetTitle className={cn("text-lg font-semibold text-[#344054]", !title && "sr-only")}>
                {title ?? fallbackTitle}
              </SheetTitle>
              {headerAction}
            </div>
          ) : (
            <SheetTitle className="sr-only">{fallbackTitle}</SheetTitle>
          )}

          {children}
        </div>
      </SheetContent>
    </Sheet>
  )
}
